(() => {
  const ROOT_SELECTOR = '[data-am-faqs]';
  const CATEGORY_SELECTOR = '.am-faqs__category[id]';
  const ACTIVE_CLASS = 'is-active';

  const getScrollOffset = () => {
    const rootStyles = window.getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
    return headerHeight + 24;
  };

  const scrollToCategory = (category, behavior = 'smooth') => {
    const top = category.getBoundingClientRect().top + window.scrollY - getScrollOffset();
    window.scrollTo({ top, behavior });
  };

  const setActiveCategory = (root, categories, activeId) => {
    categories.forEach((category) => {
      category.classList.toggle(ACTIVE_CLASS, category.id === activeId);
    });

    if (activeId) {
      root.setAttribute('data-active-category', activeId);
    } else {
      root.removeAttribute('data-active-category');
    }
  };

  const setupHashLinks = (root, categories) => {
    const hash = window.location.hash.replace('#', '');
    if (!hash) return;

    const target = categories.find((category) => category.id === hash);
    if (!target) return;

    setActiveCategory(root, categories, target.id);
    window.requestAnimationFrame(() => {
      scrollToCategory(target, 'auto');
    });
  };

  const setupCategoryObserver = (root, categories) => {
    if (!('IntersectionObserver' in window)) {
      setActiveCategory(root, categories, categories[0]?.id || '');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((entryA, entryB) => entryB.intersectionRatio - entryA.intersectionRatio);

        if (!visible.length) return;

        const activeCategory = visible[0].target;
        if (!activeCategory?.id) return;

        if (window.location.hash !== `#${activeCategory.id}`) {
          window.history.replaceState(null, '', `#${activeCategory.id}`);
        }

        setActiveCategory(root, categories, activeCategory.id);
      },
      {
        root: null,
        rootMargin: `-${getScrollOffset()}px 0px -55% 0px`,
        threshold: [0.2, 0.45, 0.7],
      },
    );

    categories.forEach((category) => observer.observe(category));
  };

  const setup = (root) => {
    const categories = Array.from(root.querySelectorAll(CATEGORY_SELECTOR));
    if (!categories.length) return;

    setActiveCategory(root, categories, categories[0].id);
    setupHashLinks(root, categories);
    setupCategoryObserver(root, categories);

    window.addEventListener('hashchange', () => {
      const hash = window.location.hash.replace('#', '');
      const target = categories.find((category) => category.id === hash);
      if (!target) return;

      scrollToCategory(target);
      setActiveCategory(root, categories, target.id);
    });
  };

  const init = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    return;
  }

  init();
})();
